import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { usersAdminV2Service } from '../services/users-admin-v2.service'

/**
 * Usuarios activos (`{ id: usr_, fullName }`) para los selectores de asignación
 * de personas —el multi-select de autorizadores de un proyecto—, contra el
 * endpoint dedicado `GET /admin/users/lookup`. Sólo corre con sesión staff v2 y
 * se cachea largo: la lista cambia poco.
 */
export const useUsersV2SelectionQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.users.selectionV2(),
    queryFn: async () => await usersAdminV2Service.selectionLookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
